"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _dialogColor = require("./dialogColor");

var _dialogColor2 = _interopRequireDefault(_dialogColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DialogConfig = function () {
  function DialogConfig(title, content, contentUrl, type) {
    (0, _classCallCheck3.default)(this, DialogConfig);

    this.title = title;
    this.content = content;
    this.contentUrl = contentUrl;
    this.type = type;
  }

  (0, _createClass3.default)(DialogConfig, null, [{
    key: "red",
    value: function red(content, title) {
      return new DialogConfig(title, content, null, _dialogColor2.default.RED);
    }
  }, {
    key: "primary",
    value: function primary(content, title) {
      return new DialogConfig(title, content, null, _dialogColor2.default.ORANGE);
    }
  }, {
    key: "success",
    value: function success(content, title) {
      return new DialogConfig(title, content, null, _dialogColor2.default.GREEN);
    }
  }]);
  return DialogConfig;
}();

exports.default = DialogConfig;


// WEBPACK FOOTER //
// ./client/app/common/models/dialog/dialogConfig.js